module.exports = __webpack_public_path__ + "img/a7ece69.png";